import React, { Children } from 'react';
import Button from "../Button/Button";
import DropdownItem from "../Dropdown/DropdownItem";
import DropdownMenu from "../Dropdown/DropdownMenu";
import Input from "../Input/Input";
var defaultProps = {
  allowCreation: false,
  maxHeight: '12rem',
  noResultsLabel: 'No results found'
};

var FilteredComboboxItems = function FilteredComboboxItems(_ref) {
  var _ref$allowCreation = _ref.allowCreation,
      allowCreation = _ref$allowCreation === void 0 ? defaultProps.allowCreation : _ref$allowCreation,
      children = _ref.children,
      filterValue = _ref.filterValue,
      filterInputRef = _ref.filterInputRef,
      _ref$maxHeight = _ref.maxHeight,
      maxHeight = _ref$maxHeight === void 0 ? defaultProps.maxHeight : _ref$maxHeight,
      _ref$noResultsLabel = _ref.noResultsLabel,
      noResultsLabel = _ref$noResultsLabel === void 0 ? defaultProps.noResultsLabel : _ref$noResultsLabel,
      onCreateClick = _ref.onCreateClick,
      onFilterChange = _ref.onFilterChange;
  return /*#__PURE__*/React.createElement("div", {
    className: "d-flex flex-column h-100"
  }, /*#__PURE__*/React.createElement(DropdownMenu, {
    className: "border-secondary w-100",
    updateOnSelect: true
  }, /*#__PURE__*/React.createElement("div", {
    className: "p-3"
  }, /*#__PURE__*/React.createElement(Input, {
    "aria-label": "Filter available items",
    innerRef: filterInputRef,
    onChange: function onChange(e) {
      return onFilterChange === null || onFilterChange === void 0 ? void 0 : onFilterChange(e.target.value);
    },
    tabIndex: 0,
    value: filterValue
  })), /*#__PURE__*/React.createElement("div", {
    className: "overflow-auto",
    style: {
      maxHeight: maxHeight
    }
  }, Children.count(children) === 0 ? /*#__PURE__*/React.createElement("span", {
    className: "text-muted ps-2"
  }, noResultsLabel) : children), allowCreation && filterValue !== '' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DropdownItem, {
    divider: true
  }), /*#__PURE__*/React.createElement(Button, {
    color: "link",
    onClick: function onClick() {
      return onCreateClick === null || onCreateClick === void 0 ? void 0 : onCreateClick(filterValue);
    }
  }, "Create ", filterValue))));
};

FilteredComboboxItems.displayName = "FilteredComboboxItems";
export default FilteredComboboxItems;